<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <div class="query-panel">
                    <el-form :inline="true">
                        <el-form-item>
                            <el-button type="primary" @click="showDataEdit">编辑</el-button>
                            <el-button type="primary" @click="saveData">保存</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <el-table :data="customLimitData" border>
                    <el-table-column prop="id" label="编号">
                    </el-table-column>
                    <el-table-column prop="key_desc" label="开关描述">
                    </el-table-column>
                    <el-table-column label='状态'>
                    <template slot-scope="scope">
                        <span v-if="scope.row.key_value == 1">开放</span>
                        <span v-if="scope.row.key_value == 0">关闭</span>
                    </template>
                    </el-table-column>
                    <el-table-column label='操作处理'>
                        <template slot-scope="scope" v-if="isEditShow">
                            <el-radio-group v-model="scope.row.key_value" @input="getRadio(scope.row.id)">
                                <el-radio :label="0">关闭</el-radio>
                                <el-radio :label="1">开放</el-radio>
                            </el-radio-group>
                        </template>
                    </el-table-column>
                </el-table>
            </section>
        </div>
    </el-card>
</template>

<script>
    import {mapState} from 'vuex';
    import confApi from '../../service/conf_api'
    import worldApi from '../../service/world_api'
    import gameApi from '../../service/game_api'
    import beastsApi from '../../service/beasts_api'

    export default {
        name: "custom_limit",
        data () {
            return {
                customLimitData: [],
                editedIdData: [],
                isEditShow: false
            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverWorldList: state => state.server.serverWorldList,
                serverGameList: state => state.server.serverGameList,
            }),
        },
        mounted() {
            this.getCustomLimit();
        },
        methods: {
            // 获取自定义限制数据
            getCustomLimit() {
                var self = this;
                confApi.getReadData({
                    token: self.token,
                    tableName: 'functionopen'
                }).then(res => {
                    self.customLimitData = res;
                })
            },

            showDataEdit() {
                this.isEditShow = true;
            },

            saveData() {
                var data = this.customLimitData;
                var editedIdData = this.noRepeat(this.editedIdData);
                var functionSwitchBO = {};
                for (var i in data) {
                    for (var j in editedIdData) {
                        if (data[i].id == editedIdData[j]) {
                            functionSwitchBO[data[i].id] = data[i].key_value;
                        }
                    }
                }

              confApi.functionSwitch({
                    token: this.token,
                    functionSwitchBO: {
                        functionSwitch: functionSwitchBO
                    }
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '保存成功'
                    });
                    this.isEditShow = false;
                    this.editedIdData = [];
                    //this.reloadAxiosALLGameAndWorld();
                    this.reloadAxiosALLGameAndWorld2();
                })
            },

            noRepeat(arr){
                var newArr = [...new Set(arr)];
                return newArr
            },
            getRadio(id) {
                this.editedIdData.push(id);
            },

            reloadAxiosALLGameAndWorld2(){
                beastsApi.reloadClzName({
                    token: this.token,
                    reloadForm: {
                        reloadTypes: ['wholeGame', 'wholeWorld'],
                        gameNumbers: [],
                        worldNumbers: [],
                        reloadMode: '1',
                        clzName: 'FunctionOpenConfig'
                    }
                }).then(res => {})
            },

            // 重载全部游戏服和世界服
            reloadAxiosALLGameAndWorld() {
                let self = this;
                var reloadConfigData = [];

                self.serverGameList.forEach(serverGameItem => {
                    reloadConfigData.push({
                        uri: serverGameItem.inner_urls.split(';')[0],
                        type: 'game',
                    })

                    var balanceIps = serverGameItem.inner_urls.split(';');
                    balanceIps.shift();
                    if (balanceIps !== null && balanceIps[0] !== '' && balanceIps.length > 0) {
                        balanceIps.forEach(balanceIpsItem => {
                            reloadConfigData.push({
                                uri: balanceIpsItem,
                                type: 'game',
                            })
                        });
                    }
                })

                self.serverWorldList.forEach(serverWorldItem => {
                    reloadConfigData.push({
                        uri: serverWorldItem.inner_urls.split(';')[0],
                        type: 'world',
                    })

                    var balanceIps = serverWorldItem.inner_urls.split(';');
                    balanceIps.shift();
                    if (balanceIps !== null && balanceIps[0] !== '' && balanceIps.length > 0) {
                        balanceIps.forEach(balanceIpsItem => {
                            reloadConfigData.push({
                                uri: balanceIpsItem,
                                type: 'world',
                            })
                        });
                    }
                })

                reloadConfigData.forEach(reloadItem => {
                    let reloadForm = {};
                    if (reloadItem.type == 'world') {
                        reloadForm = {
                            worldUri: reloadItem.uri,
                            type: reloadItem.type,
                            className: 'FunctionOpenConfig'
                        }

                        worldApi.worldReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {

                        })
                    } else if (reloadItem.type == 'game') {
                        reloadForm = {
                            uri: reloadItem.uri,
                            type: reloadItem.type,
                            className: 'FunctionOpenConfig'
                        }

                        gameApi.gameReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {

                        })
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/maintenance/customer_limit.vue